import axios from "axios";
import { outputLog } from "./CommonFunction";
/*------ Ampljify ------*/
/*======  Define global variables/functions   ======*/
const consoleLogOutput = false;	//コンソールログ個別出力制御用


/* S3にファイルアップロード */
export const fileUploadS3 = async(file,callback) =>{
    /* オプション設定 */
    const option = {
        headers: {
            'Content-Type': file.contentType
            }
    };
        await axios.put(file.signedUrl,file.fileData,option)
        .then((res) => {    //正常
            outputLog("useProvideData getDataPost API.post OK", consoleLogOutput);
            outputLog(res, consoleLogOutput);
            callback({ isSuccessed: true, message: "", responseData: res });
        })
        .catch((e) => { //異常
    
            // console.log('%s',e)
    
            outputLog("useProvideData getDataPost API.post NG(abnormal)", consoleLogOutput);
            outputLog(e.response, consoleLogOutput);
            callback({ isSuccessed: false, location: "getDataPost", message: e.message, responseData: e.response });
        });
    return {
        fileUploadS3
    }
}
/* S3からファイルダウンロード */
export const fileDownload3 = async(url,type,callback) =>{
    await axios({
        url:url,
        method:'GET',
        responseType:'blob'
    })
    .then((res) => {    //正常
        outputLog("useProvideData getDataPost API.post OK", consoleLogOutput);
        outputLog(res, consoleLogOutput);
        callback({ isSuccessed: true, message: "", responseData: res });
    })
    .catch((e) => { //異常

        // console.log('%s',e)

        outputLog("useProvideData getDataPost API.post NG(abnormal)", consoleLogOutput);
        outputLog(e.response, consoleLogOutput);
        callback({ isSuccessed: false, location: "getDataPost", message: e.message, responseData: e.response });
    });
    return {
        fileDownload3
    }
}

/*------　ファイルがアップロード済みかをチェック(一時保存) ------*/
export const uploadCheckFiles = async(file,tempFile,checkFiles,uploadS3Payload) => {
    if(file){
        if(tempFile){
            //未アップロードのファイルをcheckFileに追加
            file.forEach((check)=>{
                const checkName = check.name || check.fileName;
                if(tempFile.some(file=>file.fileName === checkName || file.name === checkName)){
                    //アップロード済み
                }else{
                    //未アップロード
                    checkFiles.push({
                        fileName:checkName,
                        contentType:check.type === '' ? 'none' : check.type
                    })
                    uploadS3Payload.push({
                        fileData:check,
                        contentType:check.type === '' ? 'none' : check.type
                    })
                };
            });
        }else{
            //まだアップしたファイルが存在しないので全てアップロード対象
            file.forEach((check)=>{
                const checkName = check.name || check.fileName;
                checkFiles.push({
                    fileName:checkName,
                    contentType:check.type === '' ? 'none' : check.type
                })
                uploadS3Payload.push({
                    fileData:check,
                    contentType:check.type === '' ? 'none' : check.type
                })
            });
        }
    }
};
